/**
 * Created by Andriyanto.
 * E-Mail Address: 4lenour@gmail.com
 * Date: 29/10/2024
 */

export const sweetAlertHelper = {
    /**
     * Delete a confirmation dialog
     * @param {function} onConfirm - Callback function for confirm action
     * @param {function} onCancel - Callback function for cancel action
     * @param {object} options - Additional options for customization
     */
    deleteConfirmation(onConfirm, options = {}, onCancel = ()=>{}) {
        const defaultOptions = {
            title: "Are you sure?",
            html: "The data will be permanently deleted and cannot be recovered!",
            icon: "question",
            showCancelButton: true,
            confirmButtonText: "Yes, delete it!",
            customClass: {
                confirmButton: 'btn btn-primary',
                cancelButton: 'btn btn-secondary'
            },
            buttonsStyling: false
        };

        const alertOptions = {
            ...defaultOptions,
            ...options
        };

        window.Swal.fire(alertOptions).then((result) => {
            if (result.isConfirmed) {
                if (onConfirm) onConfirm();
            } else if (result.isDismissed) {
                if (onCancel) onCancel();
            }
        });
    },
    confirmation(title, message, confirmButtonText, onConfirm, onCancel = ()=>{}) {
        const options = {
            title: title,
            html: message,
            icon: "question",
            showCancelButton: true,
            confirmButtonText: confirmButtonText,
            customClass: {
                confirmButton: 'btn btn-primary',
                cancelButton: 'btn btn-secondary'
            },
            buttonsStyling: false
        };

        window.Swal.fire(options).then((result) => {
            if (result.isConfirmed) {
                if (onConfirm) onConfirm();
            } else if (result.isDismissed) {
                if (onCancel) onCancel();
            }
        });
    },
    alert(title, message, icon) {
        window.Swal.fire({
            title: title,
            html: message,
            icon: icon,
            confirmButtonText: "OK",
            customClass: {
                confirmButton: 'btn btn-primary'
            },
            buttonsStyling: false
        }).then((result) => {});
    }
}
